import { JSConn } from "@/utilities/js-conn";
import { map as Rmap } from "ramda";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { format, formatDistance } from "date-fns";
import TipTapDisplay from "@/components/TipTapDisplay/TipTapDisplay";
import { ordinalize } from "@/utilities/ordinalize";

export default {
  name: "workOrderPrint",
  props: { workOrderId: String },
  components: {
    LoadingAnimation,
    TipTapDisplay,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Work Order...",
      sortBy: "item_date",
      lineItemFields: [
        { key: "item_date", label: "Date", sortable: false },
        { key: "quantity", label: "Quantity", sortable: false },
        { key: "description", label: "Description", sortable: false },
        { key: "rate", label: "Rate", sortable: false },
        { key: "total", label: "Total", sortable: false },
      ],
    };
  },
  created() {
    this.loadWorkOrder().then(() => {
      this.dataLoaded = true;
    });
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    isFieldWorker: function() {
      return this.$store.getters.isFieldWorker;
    },
    workOrderNotes: function() {
      const apiNotes = this.$store.getters.workOrderNotes;
      const rightNow = new Date();
      return Rmap(nt => {
        const createdAt = new Date(nt.created_at);
        const humanizedDate = format(createdAt, "MMMM d, yyyy, h:mm a");
        const time_ago_in_words = formatDistance(rightNow, createdAt) + " ago";
        return {
          ...nt,
          humanized_created_at: humanizedDate,
          time_ago_in_words: time_ago_in_words,
        };
      }, apiNotes);
    },
    workOrderInstructions: function() {
      return this.$store.getters.workOrderInstructions;
    },
  },
  methods: {
    ordinalize: function(i) {
      return ordinalize(i);
    },
    loadWorkOrder() {
      const jsConnWorkOrder = new JSConn();
      const jsConnLineItems = new JSConn();
      const jsConnLotUnits = new JSConn();

      jsConnWorkOrder.formParams = {
        id: this.workOrderId,
      };

      const dataPromises = [
        this.$store.dispatch("needWorkOrder", jsConnWorkOrder),
        this.$store.dispatch("needLotUnits", jsConnLotUnits),
        this.$store.dispatch("needLineItems", jsConnLineItems),
      ];

      return Promise.all(dataPromises);
    },
  },
};
